export default {"src":"/_next/static/media/Female-04.bdf51dd5.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};